<template>
     <div
        class="my-2"
        :class="isMobile ? 'w-full' : ''"
    >
        <vs-button
            :disabled="disabled"
            class="mr-3 mobile-hidden"
            v-if="showBackward() || onEditMode()"
            color="primary"
            type="border"
            @click="e => this.$emit('click')"
        >
            {{
                onEditMode()
                ? 'Cancelar'
                : 'Voltar'
            }}
        </vs-button>
        <vs-button
            :disabled="disabled"
            class="back sm:hidden"
            type="border"
            v-if="showBackward() || onEditMode()"
            :style="{color: color, borderColor: color}"
            @click="e => this.$emit('click')"
        >
             {{
                onEditMode()
                ? 'Cancelar'
                : 'Voltar'
            }}
        </vs-button>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
    name: 'backward-button',
    props: {
        disabled: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapGetters('step', ['isLastStep', 'isSecondStep']),
        ...mapState('company', ['company']),

        color() {
            return this.company.base_hexcolor || '#1551b1'
        },

        isMobile() {
            return window.innerWidth < 1024
        }
    },
    methods: {
        onEditMode() {
            const currentPath = this.$router.history.current.name;
            return (currentPath.slice(0, 4) == 'edit')
        },

        showBackward() {
            return this.isSecondStep ? false : true;
        },
    }
}
</script>

<style scoped>
.back {
    width: 100%;
    display: flex;
    justify-content: center;
    padding: .85rem 2.5rem;
    border: 1px solid;
    margin-top: 16px;
    color: white;
}
</style>